import React from "react";

const DLReadersHistoryModal = ({
  isOpen,
  onClose,
  readers = [],
  prevReaders = [],
  modifiedRecipientsList = [],
  modalMode = "modified",
  selectedLanguage,
}) => {
  if (!isOpen) return null;

  const isReaderHighlighted = (reader) => {
    const rEmail = (reader.email || reader.Email || "").trim().toLowerCase();
    const rId = reader.id || reader.Id;

    const prev = Array.isArray(prevReaders) ? prevReaders.find((p) => {
      const pEmail = (p.email || p.Email || "").trim().toLowerCase();
      const pId = p.id || p.Id;
      return (rId && pId && String(rId) === String(pId)) || (rEmail && pEmail && rEmail === pEmail);
    }) : null;

    const isNew = !prev;

    if (modalMode === "new") {
      return isNew;
    }
    if (modalMode === "modified") {
      if (isNew) return false;
    }

    // Check if directly in modifiedRecipientsList from backend
    if (Array.isArray(modifiedRecipientsList) && modifiedRecipientsList.length > 0) {
      const foundInModified = modifiedRecipientsList.some((m) => {
        const mEmail = (m.email || m.Email || "").trim().toLowerCase();
        const mId = m.id || m.Id;
        return (rId && mId && String(rId) === String(mId)) || (rEmail && mEmail && rEmail === mEmail);
      });
      if (foundInModified) return true;
    }

    if (prev) {
      const prevEnabled = prev.enabled ?? prev.Enabled ?? true;
      const currEnabled = reader.enabled ?? reader.Enabled ?? true;
      const prevStatus = prev.status || prev.Status || (prevEnabled ? "Active" : "Banned");
      const currStatus = reader.status || reader.Status || (currEnabled ? "Active" : "Banned");

      if (prevEnabled !== currEnabled || prevStatus !== currStatus) return true;
      if ((prev.firstName || "").trim() !== (reader.firstName || "").trim()) return true;
      if ((prev.lastName || "").trim() !== (reader.lastName || "").trim()) return true;
      if ((prev.mobileNumber || "").trim() !== (reader.mobileNumber || "").trim()) return true;
      if ((prev.mobileCountryCode || "").trim() !== (reader.mobileCountryCode || "").trim()) return true;
      if ((prev.reference || "").trim() !== (reader.reference || "").trim()) return true;
      if ((prev.authType || "").trim() !== (reader.authType || "").trim()) return true;
      if ((prev.canPrint ?? false) !== (reader.canPrint ?? false)) return true;
      if ((prev.maxPrintsPerReader ?? "") !== (reader.maxPrintsPerReader ?? "")) return true;
    }

    return isNew && modalMode !== "modified";
  };

  const getReaderStatus = (reader) => {
    const rEmail = (reader?.email || reader?.Email || "").trim().toLowerCase();
    const rId = reader?.id || reader?.Id;

    let currStatus = reader?.status || reader?.Status;
    let currEnabled = reader?.enabled ?? reader?.Enabled;

    if (Array.isArray(modifiedRecipientsList) && modifiedRecipientsList.length > 0) {
      const foundInModified = modifiedRecipientsList.find((m) => {
        const mEmail = (m?.email || m?.Email || "").trim().toLowerCase();
        const mId = m?.id || m?.Id;
        return (rId && mId && String(rId) === String(mId)) || (rEmail && mEmail && rEmail === mEmail);
      });
      if (foundInModified) {
        if (foundInModified.status !== undefined || foundInModified.Status !== undefined) {
          currStatus = foundInModified.status || foundInModified.Status;
        }
        if (foundInModified.enabled !== undefined || foundInModified.Enabled !== undefined) {
          currEnabled = foundInModified.enabled ?? foundInModified.Enabled;
        }
      }
    }

    const sLower = String(currStatus || "").trim().toLowerCase();
    if (sLower === "pause") {
      return selectedLanguage?.LstLanguageCodes?.UI_Pause?.trim() || "Pause";
    }
    if (sLower === "banned" || currEnabled === false || currEnabled === "false") {
      return selectedLanguage?.LstLanguageCodes?.UI_Banned?.trim();
    }
    if (sLower === "active" || currEnabled === true || currEnabled === "true") {
      return selectedLanguage?.LstLanguageCodes?.UI_Active?.trim();
    }

    return selectedLanguage?.LstLanguageCodes?.UI_Active?.trim();
  };

  return (
    <div
      className="modalCus child-popup"
      style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.45)", zIndex: 1100, overflowY: "auto", }}
      onClick={onClose}>
      <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "750px", width: "95%", margin: "1.75rem auto" }} onClick={(e) => e.stopPropagation()}><div
        className="modal-content"
        style={{ borderRadius: "8px", boxShadow: "0 5px 20px rgba(0, 0, 0, 0.25)", border: "1px solid #ced4da", backgroundColor: "#ffffff", }}>
        {/* Header */}
        <div className="modal-header d-flex align-items-center justify-content-between" style={{ padding: "14px 20px", borderBottom: "1px solid #e9ecef", }}>
          <h5 className="modal-title fw-bold mb-0" style={{ color: "#212529", fontSize: "16px", fontWeight: "700", lineHeight: "1.5", margin: 0, }}>{selectedLanguage?.LstLanguageCodes?.UI_ReadersWhoAccessedtheRPD}</h5>
          <button type="button" className="btn btn-outline-danger modalclose download" onClick={onClose}>
            <span className="material-icons font-20"> highlight_off</span>
          </button>
        </div>

        {/* Table Body */}
        <div className="modal-body" style={{ padding: "16px 20px", backgroundColor: "#ffffff", }}>
          <div className="table-responsive" style={{ maxHeight: "380px", overflowY: "auto", border: "1px solid #e2e8f0", borderRadius: "6px", }}>
            <table className="table mb-0" style={{ width: "100%", borderCollapse: "collapse", }}>
              <thead>
                <tr
                  style={{ backgroundColor: "#f0f3fa", borderBottom: "1px solid #e2e8f0", }}>
                  <th className="borderRight" style={{ padding: "10px 14px", color: "#475569", fontWeight: "600", fontSize: "13px", borderTop: "none", borderRight: "1px solid #e2e8f0", width: "30%", }}>
                    {selectedLanguage?.LstLanguageCodes?.UI_Email}
                  </th>
                  <th className="borderRight" style={{ padding: "10px 14px", color: "#475569", fontWeight: "600", fontSize: "13px", borderTop: "none", borderRight: "1px solid #e2e8f0", width: "18%", }}>
                    {selectedLanguage?.LstLanguageCodes?.UI_FirstName}
                  </th>
                  <th className="borderRight" style={{ padding: "10px 14px", color: "#475569", fontWeight: "600", fontSize: "13px", borderTop: "none", borderRight: "1px solid #e2e8f0", width: "18%", }}>
                    {selectedLanguage?.LstLanguageCodes?.UI_LastName}
                  </th>
                  <th className="borderRight" style={{ padding: "10px 14px", color: "#475569", fontWeight: "600", fontSize: "13px", borderTop: "none", borderRight: "1px solid #e2e8f0", width: "18%", }}>
                    {selectedLanguage?.LstLanguageCodes?.UI_MobileNumber}
                  </th>
                  <th style={{ padding: "10px 14px", color: "#475569", fontWeight: "600", fontSize: "13px", borderTop: "none", width: "16%", }}>
                    {selectedLanguage?.LstLanguageCodes?.UI_Status}
                  </th>
                </tr>
              </thead>
              <tbody>
                {readers.length === 0 ? (
                  <tr>
                    <td colSpan={5} className="text-center py-4 text-muted">
                      {selectedLanguage?.LstLanguageCodes?.UI_Norecordfound}
                    </td>
                  </tr>) : (
                  readers.map((reader, idx) => {
                    const isHighlighted = isReaderHighlighted(reader);
                    const email = reader.email || reader.Email || "";
                    const firstName = reader.firstName || reader.FirstName || "";
                    const lastName = reader.lastName || reader.LastName || "";
                    const countryCode = reader.mobileCountryCode || reader.MobileCountryCode || "";
                    const mobile = reader.mobileNumber || reader.MobileNumber || "";
                    const fullMobile = mobile ? countryCode ? `${countryCode} ${mobile}` : mobile : "";
                    const statusVal = getReaderStatus(reader);

                    return (
                      <tr key={`dl-member-${idx}`} className={isHighlighted ? "bgYellow" : ""} style={{ backgroundColor: isHighlighted ? "yellow" : "#ffffff", borderBottom: "1px solid #e2e8f0", }}>
                        <td className="borderRight" style={{ padding: "10px 14px", fontSize: "13px", color: "#1e293b", wordBreak: "break-word", borderRight: "1px solid #e2e8f0", backgroundColor: isHighlighted ? "yellow" : "transparent", }}>
                          {email}
                        </td>
                        <td className="borderRight" style={{ padding: "10px 14px", fontSize: "13px", color: "#1e293b", borderRight: "1px solid #e2e8f0", backgroundColor: isHighlighted ? "yellow" : "transparent", }}>
                          {firstName}
                        </td>
                        <td className="borderRight" style={{ padding: "10px 14px", fontSize: "13px", color: "#1e293b", borderRight: "1px solid #e2e8f0", backgroundColor: isHighlighted ? "yellow" : "transparent", }}>
                          {lastName}
                        </td>
                        <td className="borderRight" style={{ padding: "10px 14px", fontSize: "13px", color: "#1e293b", borderRight: "1px solid #e2e8f0", backgroundColor: isHighlighted ? "yellow" : "transparent", }}>
                          {fullMobile}
                        </td>
                        <td style={{ padding: "10px 14px", fontSize: "13px", color: "#1e293b", backgroundColor: isHighlighted ? "yellow" : "transparent", }}>
                          {statusVal}
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
};

export default DLReadersHistoryModal;